import React from 'react'
import './DescriptionBox.css'

const DescriptionBox = () => {
  return (
    <div className='descriptionbox'>
        <div className="descriptionbox_navigator">
            <div className="descriptionbox_nav_box">Description</div>
            <div className="descriptionbox_nav_box fade">(122)</div>
        </div>
        <div className="descriotionbox_description">
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. 
            Magni laborum beatae, ex possimus ad quidem, similique quis reiciendis, 
            veniam saepe ullam accusantium voluptate
             eligendi commodi quo nemo quae perferendis soluta.
             Lorem ipsum dolor sit amet consectetur adipisicing elit. 
            Magni laborum beatae, ex possimus ad quidem, similique quis reiciendis, 
            veniam saepe ullam accusantium voluptate
             eligendi commodi quo nemo quae perferendis soluta.</p>
             <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. 
            Magni laborum beatae, ex possimus ad quidem, similique quis reiciendis, 
            veniam saepe ullam accusantium voluptate
             eligendi commodi quo nemo quae perferendis soluta.</p>
        </div>
    </div>
  )
}

export default DescriptionBox